import {
  Activity,
  Building2,
  Database,
  Gauge,
  type LucideIcon,
  Network,
  ScrollText,
  SlidersHorizontal,
  Users,
} from 'lucide-react';

/**
 * The console's destinations, in one place because two things read them: the
 * rail draws them, and `PageHeader` takes a page's glyph from them — the same
 * arrangement the product uses, so a screen wears the same icon in its title
 * as it does in the rail without naming it twice.
 */

export interface NavEntry {
  name: string;
  href: string;
  icon: LucideIcon;
}

export const NAVIGATION: NavEntry[] = [
  { name: 'Partners', href: '/partners', icon: Network },
  { name: 'Organizations', href: '/organizations', icon: Building2 },
  { name: 'Users', href: '/users', icon: Users },
  { name: 'Ingest health', href: '/health', icon: Activity },
  { name: 'Audit trail', href: '/audit', icon: ScrollText },
  { name: 'Calculators', href: '/calculators', icon: SlidersHorizontal },
  { name: 'Sensor mappings', href: '/sensor-mappings', icon: Gauge },
  { name: 'Retention', href: '/retention', icon: Database },
];

/** The entry a path belongs to: the longest `href` it starts with. */
export function entryFor(pathname: string): NavEntry | undefined {
  return NAVIGATION.filter(
    (entry) => pathname === entry.href || pathname.startsWith(`${entry.href}/`)
  ).sort((a, b) => b.href.length - a.href.length)[0];
}
